import React, { useState } from "react";
import { QuestionMarkCircleIcon } from "@heroicons/react/solid";

import EasyTrans from "../bundel/EasyTrans";
import { Modal } from "../ui";

/**
 * Inline "?" help. Clicking opens a small centered dialog with the title +
 * message — robust for long text and on mobile (the popover variant overflowed
 * the viewport near edges). Closes on Escape / click-outside / the × button.
 */
const HelpIcon = (props) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-label="Help"
        onClick={() => setOpen(true)}
        className="m-1 rounded-full text-gray-500 transition-colors hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-fairblue-500"
      >
        <QuestionMarkCircleIcon className="h-5 w-5" aria-hidden="true" />
      </button>

      <Modal open={open} onClose={() => setOpen(false)} panelClassName="max-w-md">
        <div className="rounded-2xl bg-white p-6">
          {props.Title && (
            <h3 className="pr-6 text-base font-semibold text-gray-900">
              <EasyTrans>{props.Title}</EasyTrans>
            </h3>
          )}
          <p className="mt-2 text-sm leading-relaxed text-gray-600">
            {typeof props.TransKey === "string" ? (
              <EasyTrans>{props.TransKey}</EasyTrans>
            ) : (
              props.Message
            )}
          </p>
        </div>
      </Modal>
    </>
  );
};

export default HelpIcon;
